var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonEndInner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 46"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17670",
    d: "M16 46a7.322 7.322 0 01-5.924-3.453l-9.2-16.094a6.736 6.736 0 01-.745-4.679 7.906 7.906 0 01.746-2.228l9.2-16.091A7.3 7.3 0 0116 0",
    fill: "currentColor"
  })));
}
export default SvgButtonEndInner;